import type { ResourceLanguage } from 'i18next'

export enum Language {
  en = 'en',
  no = 'no',
}

export type LanguageResources = Record<Language, ResourceLanguage>
